import React, { useEffect } from "react";
import { Rept } from "../../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { mt } from "../../../../St/comps/cStyle";
import { reFormatDate } from "../../../../utils/utils";
import { insh } from "../../../../Context/InshSt";

import { colors, Container, makeStyles, Table, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";


export function Totals({ data }) {
  const styf = { fontWeight: "1200" };
  const cls = useRptAF();
  const totals = Rept.tot;

  const styleE = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    padding: 2,
    fontSize: "0.6rem",
    color: "red",
    fontWeight: "bold",
  };
  const styleTo = {
    border: "solid 1px ",
    borderColor: "black",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: "bold",
  };
  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container className={cls.rootBdyup}>
        <Grid container lg={12} md={12} className={cls.rootBdydown}>
          <Grid container xs={12} /*className={cls.rootchip}*/>
            <Grid item xs={2} style={styleE}>
              {" صافي الكميات "}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" صافي الاجمالي "}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" صافي الخصم "}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" صافي الضريبة "}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" صافي التكلفة "}
            </Grid>
            <Grid item xs={2} style={styleE}>
              {" صافي الربح "}
            </Grid>
            {/* <Grid item xs={2} className={classes.itemW}>{' صافي الكميات '}</Grid> */}
            {/* <Grid item xs={2} className={[cls.chipV,cls.chipVR]}>{Rept.tot.totval}</Grid> */}
          </Grid>
          <Grid container xs={12} /*className={cls.rootchip}*/>
            <Grid item xs={2} style={styleTo}>
              {totals?.qtyTotal.toFixed(2)}
            </Grid>
            <Grid item xs={2} style={styleTo}>
              {totals?.totNetTotal.toFixed(2)}
            </Grid>
            <Grid item xs={2} style={styleTo}>
              {totals?.minusTotal.toFixed(2)}
            </Grid>
            <Grid item xs={2} style={styleTo}>
              {totals?.vatTotal.toFixed(2)}
            </Grid>
            <Grid item xs={2} style={styleTo}>
              {totals?.costTotal.toFixed(2)}
            </Grid>
            <Grid item xs={2} style={styleTo}>
              {totals?.profitTotal.toFixed(2)}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

function BodyAnaysis({ data, isFullPage, isLast }) {
  const { t } = useTranslation(["forms", "translation"]);
  const cls = useRptAF();
  const cellS = {

    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.55rem",
    width: "150px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var columns = [
    { title: Rept.labelname, field: "txtType" },
    { title: " عدد الفواتير", field: "cnt" },
    { title: " صافي الكمية", field: "qty" },
    { title: " صافي الاجمالي", field: "totNet" },
    { title: " صافي الخصم", field: "minus" },
    { title: "  صافي الضريبة", field: "vat" },
    { title: "صافي التكلفة", field: "cost" },
    { title: "صافي الربح", field: "Profit" },

  ];


  const newData = data.map((row, i) => {
    return {
      ...row,
      totNet: parseFloat(row.totNet).toFixed(2),
      minus: parseFloat(row.minus).toFixed(2),
      vat: parseFloat(row.vat).toFixed(2),
      cost: parseFloat(row.cost).toFixed(2),
      Profit: parseFloat(row.Profit).toFixed(2),
    };
  });
  return (
    <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
      <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>
        <Grid
          item
          xs={12}

        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            // style={{direction:'ltr'}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },

            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={columns}
            data={newData}
          />
          {isLast && <Totals data={data ?? []} />}
        </Grid>
      </Grid>


    </Grid>
  );
}

export default BodyAnaysis;
